let state = {
    mAnswers: []
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/mAnswerModel/state.js